import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    proveedores: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    nombre: '',
    documentoNumero: '',
    provincia: null,
    localidad: null,
    promedioEvaluacionesMin: 0,
    promedioEvaluacionesMax: 0,
    etiqueta: '',
    categoria: '',
    incluirInactivos: false,

    list: [],
    selectList: [],

    rptProveedores: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.proveedores = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.documentoNumero = '';
        state.provincia = null;
        state.localidad = null;
        state.promedioEvaluacionesMin = 0;
        state.promedioEvaluacionesMax = 0;
        state.etiqueta = '';
        state.categoria = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR_PROVEEDORES'(state) {
        state.proveedores = [];
    },
    'PROVEEDORES'(state, proveedores) {
        state.proveedores = proveedores;
        // state.proveedores = proveedores.map(proveedor => ({
        //     ...proveedor,
        //     _showDetails: proveedor.etiquetas.length != 0? true : false
        // }));
    },
    'PROVEEDORES_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, params) {
        state.list = params.list;
        state.selectList = params.selectList;
    },
    'INICIALIZAR_RPT'(state) {
        state.rptProveedores = [];
    },
    'SET_RPT'(state, rptProveedores) {
        state.rptProveedores = rptProveedores;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getProveedores: ( {commit}, params ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PROVEEDORES')

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual

            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }
            if (state.documentoNumero != '') {
                queryString += '&documentoNumero=' + state.documentoNumero;
            }
            if (state.provincia) {
                if (state.provincia.id != 0) {
                    queryString += '&provinciaId=' + state.provincia.id;
                }
            }
            if (state.localidad) {
                if (state.localidad.id != 0) {
                    queryString += '&localidadId=' + state.localidad.id;
                }
            }
            if (state.promedioEvaluacionesMin) {
                if (state.promedioEvaluacionesMin != 0) {
                    queryString += '&promedioEvaluacionesMin=' + state.promedioEvaluacionesMin;
                }
            }
            if (state.promedioEvaluacionesMax) {
                if (state.promedioEvaluacionesMax != 0) {
                    queryString += '&promedioEvaluacionesMax=' + state.promedioEvaluacionesMax;
                }
            }
            if (state.etiqueta != '') {
                queryString += '&etiqueta=' + state.etiqueta.trim();
            }
            if (state.categoria != '') {
                queryString += '&categoria=' + state.categoria.trim();
            }
            if ((/true/i).test(state.incluirInactivos)) {
                queryString += '&incluirInactivos= true';
            }

            if (params) {
                if ((/true/i).test(params.impuestos)) {
                    queryString += (queryString.trim() == '' ? '?' : '&') + 'impuestos=true';
                }
                if (params.impuestoOrganismoId) {
                    if (params.impuestoOrganismoId != 0) {
                        queryString += '&impuestoOrganismoId=' + params.impuestoOrganismoId;
                    }
                }
            }

            apiAxios.get('proveedores' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PROVEEDORES_PAGINATION', params);
                    }
                    commit('PROVEEDORES', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getList: ({commit}, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            let queryString = '';
            
            if (params) {
                if ((/true/i).test(params.transportes)) {
                    queryString += (queryString.trim() == '' ? '?' : '&') + 'transportes=true';
                }
                if ((/true/i).test(params.impuestos)) {
                    queryString += (queryString.trim() == '' ? '?' : '&') + 'impuestos=true';
                }
                if ((/true/i).test(params.incluirInactivos)) {
                    queryString += (queryString.trim() == '' ? '?' : '&') + 'incluirInactivos=true';
                } else {
                    queryString += (queryString.trim() == '' ? '?' : '&') + 'incluirInactivos=false';
                }
            }

            apiAxios.get('proveedores/list' + queryString)
                .then(res => {
                    // let selectList = [];
                    // res.data.forEach(item => {
                    //     selectList.push(item.nombre.trim())
                    // });

                    let selectList = res.data.map(proveedor => proveedor.nombre.trim());
                    
                    let params = {
                        list: res.data,
                        selectList
                    };
                    commit('SET_LIST', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRptProveedores: ( {commit}, params ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT')

            let queryString = '';

            if (params.nombre != '') {
                queryString += (queryString.trim() == ''? '?' : '&')  + 'nombre=' + params.nombre;
            }
            if (params.documentoNumero != '') {
                queryString += (queryString.trim() == ''? '?' : '&')  + 'documentoNumero=' + params.documentoNumero;
            }
            if (params.provincia) {
                if (params.provincia.id != 0) {
                    queryString += (queryString.trim() == ''? '?' : '&')  + 'provinciaId=' + params.provincia.id;
                }
            }
            if (params.localidad) {
                if (params.localidad.id != 0) {
                    queryString += (queryString.trim() == ''? '?' : '&')  + 'localidadId=' + params.localidad.id;
                }
            }
            if (params.promedioEvaluacionesMin) {
                if (params.promedioEvaluacionesMin != 0) {
                    queryString += (queryString.trim() == ''? '?' : '&')  + 'promedioEvaluacionesMin=' + params.promedioEvaluacionesMin;
                }
            }
            if (params.promedioEvaluacionesMax) {
                if (params.promedioEvaluacionesMax != 0) {
                    queryString += (queryString.trim() == ''? '?' : '&')  + 'promedioEvaluacionesMax=' + params.promedioEvaluacionesMax;
                }
            }
            if (params.etiqueta != '') {
                queryString += (queryString.trim() == ''? '?' : '&')  + 'etiqueta=' + params.etiqueta.trim();
            }
            if (params.categoria) {
                if (params.categoria != '') {
                    queryString += (queryString.trim() == ''? '?' : '&')  + 'categoria=' + params.categoria.trim();
                }
            }
            if ((/true/i).test(params.incluirInactivos)) {
                queryString += (queryString.trim() == ''? '?' : '&')  + 'incluirInactivos= true';
            }

            apiAxios.get('proveedores/rpt' + queryString)
                .then(res => {
                    commit('SET_RPT', res.data)
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
    rptProveedores (state) {
        return state.rptProveedores;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}